import $ from "jquery";
import * as bootbox from "bootbox";
import "jquery-form";
import "jquery.uniform";
export function initializeUpload(idInput, text1, text2, msgRenameFile, msgNoFile, lblTraitementEnCours, lblRecupererFichier, lblNon, lblOui, nomTable, bddIndex, nomChamp, sExport) {
    var newName = "";
    var progress = $("#progress_" + idInput);
    var bar = $("#bar_" + idInput);
    var percent = $("#percent_" + idInput);
    $("#formSaisie_" + idInput).ajaxForm({
        beforeSubmit: function () {
            if ($("#upload_" + idInput).val() == "") {
                bootbox.alert(msgNoFile);
                return false;
            }
            else {
                return true;
            }
        },
        beforeSend: function () {
            bar.width("0%");
            percent.html("0%");
        },
        uploadProgress: function (event, position, total, percentComplete) {
            var percentVal = percentComplete + "%";
            bar.width(percentVal);
            percent.html(percentVal);
            if (percentComplete >= 95) {
                $("#listeFichiers_" + idInput).html("<div class=\"alert alert-info\"><i class=\"icon-spinner icon-spin\"></i>" + lblTraitementEnCours + "</div>");
            }
        },
        error: function (err) {
            let errorText = "";
            if (err.responseText)
                errorText = err.responseText;
            else
                errorText = err.statusText;
            $("#listeFichiers_" + idInput).html("").append($("<div>").addClass("alert alert-danger").html(errorText));
            // $("#listeFichiers_" + idInput).html("<div class='alert alert-danger'>" + err.statusText + "</div>");
            console.error(err);
        },
        success: function (responseText) {
            var myObject = responseText;
            if (myObject.result == true) {
                $("#listeFichiers_" + idInput).html("<div class=\"alert alert-success\">" + lblRecupererFichier + "</div>");
                progress.text("Uploaded");
                ProcessUpdate(nomTable, 'bbmindex', bddIndex, nomChamp, myObject.message, sExport, true);
                Seed.Tab.Reload();
            }
            else {
                if (myObject.result == false && myObject.code == "FILE_EXISTS") {
                    newName = myObject.message;
                    $("#listeFichiers_" + idInput).html("<div class=\"alert alert-warning\">"
                        + msgRenameFile.replace("%1", myObject.message)
                        + "<div class=\"btn-group\">"
                        + "<button class=\"btn btn-primary\" onclick=\"uploadController.callbackRenameUpload(\'" + idInput + "\', \'" + myObject.message + "\');\">" + lblOui + "</button>"
                        + "<button class=\"btn btn-primary\" onclick=\"Seed.Tab.Reload();\">" + lblNon + "</button>"
                        + "</div>"
                        + "</div>");
                }
                else {
                    $("#listeFichiers_" + idInput).html("<div class=\"alert alert-danger\">" + myObject.message + "</div>");
                }
            }
        }
    });
}
export function getAdvencedParam() {
    Seed.Import.getAdvencedParam();
}
/**
 * Fonction de callback pour le rennomage d'un fichier uploadé
 * Fonctionne principalement sur le model des fonctions de IO::
 * @param {type} idInput
 * @param {type} fileName
 * @returns {undefined}
 */
export function callbackRenameUpload(idInput, fileName) {
    $('#forceName_' + idInput).val(fileName);
    $('#formSaisie_' + idInput).submit();
}
//# sourceMappingURL=uploadController.js.map